import { Mutations, Getters, Actions } from 'vuex-smart-module'

import { itemsPerPageOptions, TableOptions, Header } from '@/models/tables'

import { LoadingGetters } from '@/store/modules/loading'
import { PaginationRequest } from '@/api'

export class TableState<Item = unknown> {
  itemsPerPageOptions: readonly [number, number, number] = itemsPerPageOptions
  tableItems: Array<Item> = []
  tableOptions: TableOptions = new TableOptions()
  tableHeaders: Array<Header> = null
  tableCount = 0
}

export class TableGetters<S extends TableState> extends Getters<S> {
  get tableParams(): PaginationRequest {
    return {
      limit: this.state.tableOptions.itemsPerPage,
      offset: (this.state.tableOptions.page - 1) * this.state.tableOptions.itemsPerPage,
      // field: this.state.tableOptions.sortBy[0],
      // asc: this.state.tableOptions.sortDesc[0],
    }
  }
}

export class TableLoadingGetters<A extends Actions, S extends TableState> extends LoadingGetters<A, S> {
  get tableParams() {
    return {
      limit: this.state.tableOptions.itemsPerPage,
      offset: (this.state.tableOptions.page - 1) * this.state.tableOptions.itemsPerPage,
      field: this.state.tableOptions.sortBy[0],
      asc: this.state.tableOptions.sortDesc[0],
    }
  }
}

export class TableMutations<S extends TableState> extends Mutations<S> {
  setTableItems(items: S['tableItems']) {
    this.state.tableItems = items || []
  }

  setTableCount(count: number) {
    this.state.tableCount = count
  }

  setTableOptions(tableOptions: TableOptions) {
    this.state.tableOptions = { ...this.state.tableOptions, ...tableOptions }
  }
}
